import React from 'react';
import { RefreshedSelectInput, Box, Icon } from '@spothero/ui';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilters } from 'store/filters/filters-actions';
import IconChevronDown from '@spothero/icons/chevron-down';
import { trackFilterChange } from '../../../utils/trackfilterChange';
import { getSelectItems } from './utils';
import { getMonthlyReservationTypes } from 'store/filters/filters-selectors';
import { selectFilterStyles } from '../../../filter-bases';
export const MonthlyAvailability = () => {
    const dispatch = useDispatch();
    const fullStore = useSelector((state) => state);
    const { reservationTypes, activeReservationType } = useSelector(getMonthlyReservationTypes);
    const onReservationTypeChange = ({ target, }) => {
        const { value } = target;
        const changedFilters = {
            activeReservationType: value,
        };
        dispatch(updateFilters(changedFilters));
        trackFilterChange(fullStore, changedFilters);
    };
    const options = getSelectItems(reservationTypes);
    return (<Box position="relative" sx={{
            '.chakra-select__wrapper': {
                paddingLeft: '0',
            },
            '.chakra-select': {
                width: 'unset',
                paddingRight: '8',
                maxWidth: '11rem',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
        }}>
            <RefreshedSelectInput value={activeReservationType} variant="outline" onChange={onReservationTypeChange} data-testid="monthlyReservationTypes" icon={<Icon as={IconChevronDown} marginRight={4}/>} iconSize={18} iconColor="black" {...selectFilterStyles} _focus={{
            boxShadow: 'none',
            backgroundColor: 'transparent',
        }} paddingLeft={0}>
                {options.map(({ label, value }) => (<option value={value} key={value} data-testid={`monthlyReservationTypes-${value}`}>
                        {label}
                    </option>))}
            </RefreshedSelectInput>
        </Box>);
};
